import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useHoldingClassListPage } from '../context/HoldingClassListPageContext';
import HoldingClassTable from './HoldingClassTable';

const HoldingClassListPageBody: FC = () => {
  const { data, actions } = useHoldingClassListPage();

  const showPagination =
    data.holdingClasses && data.holdingClassesTotal > (data.rowsPerPage || 10);

  return (
    <div className="nk-block">
      <HoldingClassTable />

      {showPagination && (
        <TablePagination
          totalRows={data.holdingClassesTotal || 0}
          onChangePage={actions.handleChangePage}
          onChangeRowsPerPage={actions.handleChangeRowsPerPage}
        />
      )}
    </div>
  );
};

export default HoldingClassListPageBody;
